// extracted by mini-css-extract-plugin
export default {"content":"input_content__J2zd9","input":"input_input__YwSDi"};